import { render, staticRenderFns } from "./MenuStudentListPage.vue?vue&type=template&id=2239a55d&"
import script from "./MenuStudentListPage.vue?vue&type=script&lang=js&"
export * from "./MenuStudentListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports